import GMaps from 'gmaps';

const $ = window.jQuery;
const MarkerWithLabel = require('markerwithlabel')(google.maps);

$(() => {
    function initMap() {
        const $maps = $('.map-embed');

        if (!$maps.length) {
            return;
        }

        _.each($maps, map => {
            const $map_wrap = $(map);
            const instance = $map_wrap.attr('data-instance');
            const address = $map_wrap.attr('data-address');
            const address_1 = $map_wrap.attr('data-address-1');
            const address_2 = $map_wrap.attr('data-address-2');
            const address_title = $map_wrap.attr('data-address-title');
            const map_id = `#map-embed__map-${instance}`;

            GMaps.geocode({
                address,
                callback: function(results, status) {
                    if (status == 'OK') {
                        const location = results[0].geometry.location;
                        const lat = location.lat();
                        const lng = location.lng();
                        const directions = `https://www.google.com/maps/?daddr==${address
                            .split(' ')
                            .join('+')}`;
                        const infoWindow = new google.maps.InfoWindow({
                            content: `<strong>${address_title}</strong><br/>
${address_1}<br/>
${address_2}<br/>
<a href="${directions}" target="_blank">Get Directions</a>`,
                        });

                        const gmap = new GMaps({
                            div: map_id,
                            lat,
                            lng,
                            infoWindow: infoWindow,
                        });

                        const marker = new MarkerWithLabel({
                            position: gmap.map.getCenter(),
                            labelContent: ``,
                            labelAnchor: new google.maps.Point(95, 20), // 95, 20 originally
                            labelClass: 'labels',
                            title: address_title,
                            labelStyle: {
                                opacity: 0.75,
                            },
                            zIndex: 999999,
                            map: gmap.map,
                        });

                        infoWindow.open(gmap, marker);
                    }
                },
            });
        });
    }

    google.maps.event.addDomListener(window, 'load', initMap);
});
